import React, { useEffect, useCallback } from 'react';
import {
  Box, Paper, Typography, Chip, Stack, CircularProgress,
} from '@mui/material';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import interactionPlugin from '@fullcalendar/interaction';
import { useDispatch, useSelector } from 'react-redux';
import { loadCalendarEvents } from '../../../reduxcomponents/slices/tripManagementSlice';

const EVENT_TYPE_LABELS = {
  arrival:     '✈ Check-in',
  departure:   '🏠 Return',
  payment_due: '💰 Payment',
};

const TripCalendar = ({ onEventClick }) => {
  const dispatch = useDispatch();
  const { calendarEvents, loading } = useSelector(s => s.tripManagement);

  const handleDatesSet = useCallback(({ startStr, endStr }) => {
    dispatch(loadCalendarEvents({ start: startStr, end: endStr }));
  }, [dispatch]);

  const handleEventClick = ({ event }) => {
    onEventClick?.({
      tripId:  event.extendedProps.trip_id,
      type:    event.extendedProps.type,
      title:   event.title,
    });
  };

  return (
    <Box>
      <Stack direction="row" spacing={2} mb={2} flexWrap="wrap" useFlexGap>
        <Chip label="✈ Check-in / Arrival"   sx={{ bgcolor: '#e3f2fd', color: '#1976d2', fontWeight: 600 }} size="small" />
        <Chip label="🏠 Return / Departure"  sx={{ bgcolor: '#e8f5e9', color: '#388e3c', fontWeight: 600 }} size="small" />
        <Chip label="💰 Payment Due"          sx={{ bgcolor: '#fff3e0', color: '#f57c00', fontWeight: 600 }} size="small" />
        <Chip label="❗ Overdue Payment"       sx={{ bgcolor: '#ffebee', color: '#d32f2f', fontWeight: 600 }} size="small" />
      </Stack>

      {loading.calendar && (
        <Box display="flex" justifyContent="center" py={2}>
          <CircularProgress size={24} />
        </Box>
      )}

      <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
        <FullCalendar
          plugins={[dayGridPlugin, timeGridPlugin, listPlugin, interactionPlugin]}
          initialView="dayGridMonth"
          headerToolbar={{
            left:   'prev,next today',
            center: 'title',
            right:  'dayGridMonth,timeGridWeek,listWeek',
          }}
          events={calendarEvents.map(evt => ({
            id:    evt.id,
            title: evt.title,
            date:  evt.date,
            color: evt.color,
            extendedProps: { trip_id: evt.trip_id, type: evt.type },
          }))}
          datesSet={handleDatesSet}
          eventClick={handleEventClick}
          height="auto"
          eventDisplay="block"
          eventBorderColor="transparent"
          dayMaxEvents={3}
          moreLinkClick="popover"
        />
      </Paper>
    </Box>
  );
};

export default TripCalendar;
